<template>
  <div>
    <b-row>
      <b-col sm="6" class="form-group" v-if="!readonly">
        <form-write-group-label-input v-model="SenderName" isMandatory
          :inputLabel="$t('common.email.email_sender_name')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-else>
        <form-read-group-label-input isMandatory
        :inputLabel="$t('common.email.email_sender_name')"
        :inputValue="SenderName">
        </form-read-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-if="!readonly">
        <form-write-group-label-input v-model="SenderEmail" isMandatory
          :inputLabel="$t('common.email.email_sender_email')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-else>
        <form-read-group-label-input isMandatory
        :inputLabel="$t('common.email.email_sender_email')"
        :inputValue="SenderEmail">
        </form-read-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-if="!readonly">
        <form-write-group-label-input v-model="SmtpServer" isMandatory
          :inputLabel="$t('common.email.email_sender_smtp_server')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-else>
        <form-read-group-label-input isMandatory
        :inputLabel="$t('common.email.email_sender_smtp_server')"
        :inputValue="SmtpServer">
        </form-read-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-if="!readonly">
        <form-write-group-label-input v-model="SmtpPort" isMandatory
          :inputLabel="$t('common.email.email_sender_smtp_port')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-else>
        <form-read-group-label-input isMandatory
        :inputLabel="$t('common.email.email_sender_smtp_port')"
        :inputValue="SmtpPort">
        </form-read-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-if="!readonly">
        <form-write-group-label-input v-model="SmtpUser" isMandatory
          :inputLabel="$t('common.email.email_sender_smtp_user')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-else>
        <form-read-group-label-input isMandatory
        :inputLabel="$t('common.email.email_sender_smtp_user')"
        :inputValue="SmtpUser">
        </form-read-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-if="!readonly">
        <form-write-group-label-input v-model="SmtpPassword" isMandatory
          :inputLabel="$t('common.email.email_sender_smtp_password')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-else>
        <form-read-group-label-input isMandatory
        :inputLabel="$t('common.email.email_sender_smtp_password')"
        :inputValue="SmtpPassword">
        </form-read-group-label-input>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"

export default {
  name: "EmailSenderForm",
  components: {
    'form-read-group-label-input': formReadGroupLabelInput,
    "form-write-group-label-input": formWriteGroupLabelInput
  },
  props: {
    mode: {
      type: String,
      default: "add"
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    SenderName: {
      get () {
        return this.inputValue.SenderName
      },
      set (val) {
        this.inputValue = {
          SenderName: val.trim(),
          SenderEmail: this.inputValue.SenderEmail,
          SmtpServer: this.inputValue.SmtpServer,
          SmtpPort: this.inputValue.SmtpPort,
          SmtpUser: this.inputValue.SmtpUser,
          SmtpPassword: this.inputValue.SmtpPassword
        }
      }
    },
    SenderEmail: {
      get() {
        return this.inputValue.SenderEmail
      },
      set(val) {
        this.inputValue = {
          SenderName: this.inputValue.SenderName,
          SenderEmail: val.trim(),
          SmtpServer: this.inputValue.SmtpServer,
          SmtpPort: this.inputValue.SmtpPort,
          SmtpUser: this.inputValue.SmtpUser,
          SmtpPassword: this.inputValue.SmtpPassword
        }
      }
    },
    SmtpServer: {
      get() {
        return this.inputValue.SmtpServer
      },
      set(val) {
        this.inputValue = {
          SenderName: this.inputValue.SenderName,
          SenderEmail: this.inputValue.SenderEmail,
          SmtpServer: val.trim(),
          SmtpPort: this.inputValue.SmtpPort,
          SmtpUser: this.inputValue.SmtpUser,
          SmtpPassword: this.inputValue.SmtpPassword
        }
      }
    },
    SmtpPort: {
      get() {
        return this.inputValue.SmtpPort
      },
      set(val) {
        this.inputValue = {
          SenderName: this.inputValue.SenderName,
          SenderEmail: this.inputValue.SenderEmail,
          SmtpServer: this.inputValue.SmtpServer,
          SmtpPort: val.trim(),
          SmtpUser: this.inputValue.SmtpUser,
          SmtpPassword: this.inputValue.SmtpPassword
        }
      }
    },
    SmtpUser: {
      get() {
        return this.inputValue.SmtpUser
      },
      set(val) {
        this.inputValue = {
          SenderName: this.inputValue.SenderName,
          SenderEmail: this.inputValue.SenderEmail,
          SmtpServer: this.inputValue.SmtpServer,
          SmtpPort: this.inputValue.SmtpPort,
          SmtpUser: val.trim(),
          SmtpPassword: this.inputValue.SmtpPassword
        }
      }
    },
    SmtpPassword: {
      get() {
        return this.inputValue.SmtpPassword
      },
      set(val) {
        this.inputValue = {
          SenderName: this.inputValue.SenderName,
          SenderEmail: this.inputValue.SenderEmail,
          SmtpServer: this.inputValue.SmtpServer,
          SmtpPort: this.inputValue.SmtpPort,
          SmtpUser: this.inputValue.SmtpUser,
          SmtpPassword: val.trim()
        }
      }
    }
  },
  data() {
  },
  created() {
  },
  methods: {
  }
}
</script>
